export default __webpack_public_path__ + "static/media/13-AboveTheBay.f9a15972.jpeg";